<template>
  <v-container class="py-0">
    <transition name="fade" mode="out-in" appear>
      <PageTitle class="d-block d-sm-none">Forecasts</PageTitle>
    </transition>
    <transition name="slide-left-fade" mode="out-in" appear>
      <v-tabs
        v-model="tab"
        class="mt-5 mt-sm-1"
        color="tabColor"
        slider-color="tabColor"
        center-active
        background-color="tertiary"
        show-arrows
        height="55"
      >
        <!-- Show loading tab when no reports loaded -->
        <v-tab v-if="forecastReports.length === 0 && isLoading" ripple>
          Loading...
        </v-tab>
        <!-- Show actual tabs when reports are loaded -->
        <v-tab v-for="report in forecastReports" :key="report.ReportTitle" ripple>
          {{ report.ReportTitle }} 
        </v-tab>
        <v-spacer></v-spacer>
        <span class="d-none d-sm-block">
          <PageTitle>Forecasts</PageTitle>
        </span>
      </v-tabs>
    </transition>

     <transition name="slide-fade" mode="out-in" appear>
      <div>
        <v-tabs-items v-model="tab" class="pt-2 tertiary">
          <!-- Show loading state when no reports are loaded yet -->
          <v-tab-item v-if="forecastReports.length === 0 && isLoading">
            <ForecastTable :Report="{ ReportTitle: 'Loading...', Entries: [], Total: 0 }" :isLoading="isLoading" />
          </v-tab-item>
          <!-- Show actual reports when loaded -->
          <v-tab-item v-for="report in forecastReports" :key="report.ReportTitle">
            <ForecastTable :Report="report" :isLoading="isLoading" />
          </v-tab-item> 
        </v-tabs-items>
      </div>
    </transition>
  </v-container>
</template>
<script>
import {mapGetters, mapState} from 'vuex'
import PageTitle from '@/components/Slots/PageTitle.vue'
import ForecastTable from '../components/Forecasts/ForecastTable.vue'

export default {
  components: {
    PageTitle,
    ForecastTable
  },
  created() {
    this.$store.dispatch("ManagementFeeForecast/getManagementFeeForecasts")
  },
  data() {
    return {
      tab: null
    }
  },
  computed: {
    ...mapGetters({
      forecastReports: "ManagementFeeForecast/reports"
    }),
    ...mapState({
      isLoading: state => state.ManagementFeeForecast.loading
    })
  }
}
</script>

<style>

</style>